import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="home-nav-buttons">
        <a
          href="https://invoices.flygonlc.com"
          className="invoice-studio-button-home"
          target="_blank"
          rel="noopener noreferrer"
        >
          Invoice Studio
        </a>
        <Link to="/services" className="services-button-home">
          Pay for Services
        </Link>
      </div>
      <div className="left-column">
        <div className="company-info">
          <div className="home-body">
            <div className="logo">
              <img src="/logo.png" alt="FLYGON LC" className="logo-image" />
            </div>

            <div className="home-taglines">
              <div className="detail-item">Based in Phoenix, AZ</div>
              <div className="detail-item">Est. 2020</div>
              <div className="referral-only">REFERRAL ONLY</div>
            </div>
          </div>

          <div className="copyright-section">
            <div className="copyright-text">COPYRIGHT © 2020-2026 FLYGON LC</div>
            <div className="legal-links">
              <Link to="/privacy" className="legal-link">Privacy Policy</Link>
              <span className="separator"> - </span>
              <Link to="/terms" className="legal-link">Terms and Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
